module.exports = __webpack_public_path__ + "6c30eebaeeef970d7106c32ef7caccf7.mp3";